import {
    ChangeDetectionStrategy,
    Component,
    computed,
    EventEmitter,
    input,
    Output,
} from "@angular/core";

import {
    CssSize,
    ICON_BUTTON_COLOR,
    ICON_BUTTON_RADIUS,
    ICON_BUTTON_VARIANT,
    type IconButtonColor,
    IconButtonComponent,
    IconButtonRadius,
    IconButtonVariant,
    IconSvgSize,
} from "@hermes/aphrodite-icon-button";

@Component({
    selector: "h-close-button",
    imports: [IconButtonComponent],
    templateUrl: "./close-button.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CloseButtonComponent {
    public readonly iconName = "cross";

    public readonly appearance = input<IconButtonColor>(
        ICON_BUTTON_COLOR.PRIMARY,
    );

    public readonly iconSize = input<CssSize>("10px");

    /**
     * Icon button variant ("filled", "outlined", "ghost", defaults value: "filled")
     */
    public readonly variant = input<IconButtonVariant>(
        ICON_BUTTON_VARIANT.GHOST,
    );

    public radius = input<IconButtonRadius>(ICON_BUTTON_RADIUS.NONE);

    @Output()
    public pressed: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

    public readonly iconSvgSize = computed<IconSvgSize>(() => {
        const size = this.iconSize();
        return [size, size];
    });

    public handleButtonClicked(event?: MouseEvent): void {
        this.pressed.emit(event);
    }
}
